module.exports = __webpack_public_path__ + "img/hero-dropdown-search-mazda.449805c9.png";